/* ATELIER V2 — single-page configurator logic (ecom hero + showroom)
   Contract with the crop API (papercrop, theme setting crop_api):
   - the image LOADED in the cropper is also the origin_url sent to the API,
     so crop coords (cropper.getData(), natural pixels) always match.
   - crop coords are clamped to [0, natural size]: the API rejects negatives.
   - price = variant price (per m²) × ceil(m²); cart quantity = ceil(m²).
   Cropper is locked to the wall measures: the crop box is NOT freely resizable —
   its ratio always follows the W×H inputs; the user pans/zooms the design under it.
*/
(function () {
  'use strict';

  function i18n(ns) { var el = document.getElementById('mpp-i18n'), o = {}, out = {}, d = document.createElement('textarea'); try { o = JSON.parse(el.textContent)[ns] || {}; } catch (e) {} Object.keys(o).forEach(function (k) { d.innerHTML = o[k]; out[k] = d.value; }); return out; }
  // customer-visible copy lives in the locale files (js.atelier.*, rendered by the layout as #mpp-i18n)
  var T = i18n('atelier');
  function L(k) { return Object.prototype.hasOwnProperty.call(T, k) ? T[k] : k; }   // a missing key shows its name, never "undefined"
  // single-brace placeholders, one pass: fmt('unit_conv', { w: 120, h: 250 }) → « Soit 120 × 250 cm »
  function fmt(k, vars) {
    return L(k).replace(/\{(\w+)\}/g, function (m, name) { return vars && Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : m; });
  }
  function userError(k) { var e = new Error(L(k)); e.userFacing = true; return e; }   // message shown to the customer as is

  var CFG = readJSON('a-config') || {};
  // shop rules rendered by the layout on every template (#a-shop: the cart page has no #a-config)
  var SHOP = readJSON('a-shop') || {};
  var LOCALE = document.documentElement.lang || 'fr';
  var PR = null;
  try { PR = new Intl.PluralRules(LOCALE); } catch (e) {}
  // P('grid_count', n) → grid_count_one / grid_count_other with {n}, after the language's plural rule
  function P(k, n) { return fmt(k + ((PR ? PR.select(n) === 'one' : n <= 1) ? '_one' : '_other'), { n: n }); }
  // language prefix of storefront links and fetches ('' for French, '/en' for English); /cart/*.js(on) and /checkout stay unprefixed
  var ROOT = (CFG.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var state = {
    product: null,
    cropper: null,
    wcm: (CFG.dims && CFG.dims.minW) || 100,      // the inputs start at the minimum wall (Liquid value="…")
    hcm: (CFG.dims && CFG.dims.minH) || 100,
    cache: {}, // handle -> product
    page: CFG.page || 1,        // SSR page (?page=N): the JSON loader continues from here
    pages: CFG.pages || 1,
    total: CFG.explorerCount || 0,
    firstPage: 1,
    autoLeft: 0,
    io: null,
    baseTitle: '',
    chip: CFG.explorerHandle || '',
    chipTitle: '',              // the SSR heading, read at boot
    favMode: false,
    busy: false,
    entryHandle: null,
    unit: 'cm',          // inputs shown in cm or inches; wcm/hcm stay whole centimetres
    fit: 'crop',         // papercrop v1.2 fit_mode: crop | full (whole design adapted to the wall)
    effect: 'none'       // papercrop v1.2 effect: none | bw | sepia
  };

  var els = {};
  [
    'cropImg', 'dimW', 'dimH', 'mockups', 'mirrorMode',
    'pType', 'pTitle', 'pDesc', 'wInput', 'hInput', 'materials',
    'totalPrice', 'pdDims', 'pdArea', 'pdRate',
    'cartError', 'addBtn', 'buyBtn',
    'tiles', 'grid', 'moreBtn', 'gridMore', 'gridSentinel', 'gridStatus', 'gridCount', 'pagiCur', 'pagiNext', 'exploreTitle', 'exploreBack',
    'searchInput', 'searchResults',
    'favBtn', 'favCount', 'cartBtn', 'cartCount',
    'zoomIn', 'zoomOut', 'toolReset',
    'drawerVeil', 'cartDrawer', 'drawerClose', 'drawerItems', 'drawerTotal',
    'lightbox', 'lightboxImg', 'lightboxClose', 'lightboxPrev', 'lightboxNext', 'lightboxCount'
  ].forEach(function (id) { els[id] = document.getElementById(id); });

  // this script ships on every template; only the atelier templates have the app DOM.
  // The homepage has the showroom + grid but NOT the configurator (HAS_TOOL false):
  // header, nav, cart drawer, favorites and search still run there.
  var fullCartForm = document.querySelector('[data-atelier-cart-form]');
  if (fullCartForm) bindFullCartCheckout(fullCartForm);
  if (!document.getElementById('a-config') || !els.grid) return;
  var HAS_TOOL = !!els.cropImg;

  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var eur = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY });
  var meters = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var num = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 2 });
  // wall limits of the supplier (theme settings wall_*_cm), in whole centimetres
  var LIM = CFG.dims || { minW: 100, maxW: 3000, minH: 100, maxH: 800 };
  function inRange(w, h) { return w >= LIM.minW && w <= LIM.maxW && h >= LIM.minH && h <= LIM.maxH; }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function lsJSON(k, fallback) {
    try { var v = JSON.parse(lsGet(k)); return v == null ? fallback : v; } catch (e) { return fallback; }
  }

  function cents(p) {
    if (p == null) return 0;
    if (typeof p === 'string') return Math.round(parseFloat(p.replace(',', '.')) * 100);
    return p; // Liquid + .js endpoints give cents
  }

  function money(c) { return eur.format(c / 100); }

  function normProduct(raw) {
    var rawImgs = raw.images || [];
    var lastRaw = rawImgs[rawImgs.length - 1];
    var imgs = rawImgs.map(function (im) {
      var u = typeof im === 'string' ? im : im.src;
      // Liquid image_url returns protocol-relative URLs; the crop API requires absolute
      return u && u.indexOf('//') === 0 ? 'https:' + u : u;
    });
    return {
      designW: raw.designW || (lastRaw && typeof lastRaw === 'object' && lastRaw.width) || 0,
      designH: raw.designH || (lastRaw && typeof lastRaw === 'object' && lastRaw.height) || 0,
      id: raw.id,
      handle: raw.handle,
      title: raw.title,
      url: raw.url || (ROOT + '/products/' + raw.handle),
      type: raw.product_type || raw.type || '',
      description: raw.description || null,
      variants: (raw.variants || []).map(function (v) {
        return { id: v.id, title: v.title, sku: v.sku || '', price: cents(v.price), available: v.available !== false };
      }),
      images: imgs
    };
  }

  // favourites keep a snapshot for an instant grid, tagged with the language and currency it was taken in:
  // another language or currency refreshes it from /products/<h>.js (translated title, presentment prices)
  function slim(p) {
    return { id: p.id, handle: p.handle, title: p.title, type: p.type, designW: p.designW || 0, designH: p.designH || 0, variants: p.variants, images: p.images,
      locale: LOCALE, currency: CURRENCY };
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3800);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function sized(src, w) {
    // set the shopify CDN width param (replace, never duplicate: CDN honors the FIRST one)
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ————— shared cart safety (also runs on the standalone cart template) ————— */

  // these helpers are function declarations: the cart template returns before the rest of this script runs.
  // Print files live under https://<host of the crop_api setting>/uploads/ (papercrop builds them with its
  // API_HOST); a blank, invalid or non-https setting accepts nothing (fail closed).
  function printOrigin() {
    try { var o = new URL(SHOP.printOrigin); return o.protocol === 'https:' && o.origin === SHOP.printOrigin ? o.origin : ''; } catch (e) { return ''; }
  }

  function safeCropURL(value) {
    if (typeof value !== 'string' || /[\s\\#%]/.test(value)) return '';
    try {
      var url = new URL(value), origin = printOrigin();
      if (origin && url.origin === origin && !url.username && !url.password
          && url.pathname.indexOf('/uploads/') === 0 && url.pathname.length > 9 && !url.hash
          && decodeURIComponent(url.pathname).indexOf('/..') === -1) return url.href;
      return '';
    } catch (e) { return ''; }
  }

  // material SKU suffixes (theme settings sku_premium_suffix / sku_adhesive_suffix, end of the SKU)
  function skuEnds(sku, suffix) { return !!suffix && String(sku || '').slice(-suffix.length) === suffix; }
  // products that are murals without a suffix: the creation and sample products of the theme settings
  function muralProduct(id) { return (SHOP.muralProducts || []).map(Number).indexOf(Number(id)) >= 0; }

  function wholeCentimeters(value) {
    if (typeof value !== 'string') return null;
    var text = value.trim();
    var number = Number(text.replace(/ cm$/, ''));
    if (!Number.isSafeInteger(number) || number <= 0 || text !== number + ' cm') return null;
    return number;
  }

  // a mural line: the configurator's properties, a material SKU suffix, or the creation / sample product —
  // never a word of the (translated) titles. Same rule as templates/cart.liquid.
  function muralLine(line) {
    var props = line.properties || {};
    return line.gift_card !== true && (props.Width != null || props.Height != null || props.imageURL != null || props._atelier_request_id != null ||
      skuEnds(line.sku, SHOP.skuPremium) || skuEnds(line.sku, SHOP.skuAdhesive) || muralProduct(line.product_id));
  }

  function muralCartLineError(line) {
    if (!line || !Number.isSafeInteger(line.quantity) || line.quantity <= 0) return L('cart_qty_check');
    var props = line.properties || {};
    if (!muralLine(line)) return '';
    var width = wholeCentimeters(props.Width), height = wholeCentimeters(props.Height);
    if (!width || !height || !Number.isSafeInteger(width * height)) return L('cart_dims_invalid');
    if (line.quantity !== Math.ceil(width * height / 10000)) return L('cart_qty_mismatch');
    if (!safeCropURL(props.imageURL)) return L('cart_file_missing');
    // The private request ID only recovers a new add; valid older mural lines
    // retain their native Width / Height / imageURL contract without one.
    return '';
  }

  function validateCheckoutCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return { ok: false, message: L('cart_check_failed') };
    if (!cart.items.length) return { ok: false, message: L('cart_empty') };
    var invalid = cart.items.some(function (line) { return !!muralCartLineError(line); });
    return { ok: !invalid, message: invalid ? L('cart_needs_fix') : '' };
  }

  function productConfigurationURL(line) {
    try {
      var origin = window.location.origin;
      var url = new URL(line.url || '', origin);
      if (url.origin === origin && ROOT && url.pathname.indexOf(ROOT + '/products/') === 0) return url.pathname;
      if (url.origin === origin && url.pathname.indexOf('/products/') === 0) return ROOT + url.pathname;
    } catch (e) { /* no safe product link */ }
    return ROOT + '/collections/all';
  }

  function clearRemovedPendingPurchase(requestId, cart) {
    if (!requestId || !cart || !Array.isArray(cart.items)) return;
    try {
      var pending = pendingPurchase || readPendingPurchase();
      if (!pending || pending.item.properties._atelier_request_id !== requestId) return;
      var remains = cart.items.some(function (line) { return line.properties && line.properties._atelier_request_id === requestId; });
      if (!remains) forgetPurchase();
    } catch (e) { /* normal cart removal does not depend on browser storage */ }
  }

  function bindFullCartCheckout(form) {
    var button = document.getElementById('cartCheckoutBtn');
    var error = document.getElementById('cartCheckoutError');
    var busy = false;
    function message(text) { if (error) { error.textContent = text; error.hidden = !text; } }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      busy = true;
      if (button) { button.disabled = true; button.textContent = L('cart_checking'); }
      message('');
      requestJSON('/cart.js', { cache: 'no-store' })
        .then(function (cart) {
          var result = validateCheckoutCart(cart);
          if (!result.ok) { message(result.message); return; }
          window.location.href = '/checkout';
        })
        .catch(function () { message(L('cart_check_failed')); })
        .finally(function () {
          busy = false;
          // The server-rendered gate stays authoritative for the rendered lines.
          if (button) { button.disabled = form.dataset.cartValid !== 'true'; button.textContent = L('checkout'); }
        });
    });
    form.addEventListener('click', function (event) {
      var link = event.target.closest('[data-atelier-remove]');
      if (!link) return;
      event.preventDefault();
      if (busy) return;
      busy = true;
      if (button) button.disabled = true;
      requestJSON('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: link.dataset.key, quantity: 0 })
      }).then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.some(function (item) { return item.key === link.dataset.key; })) throw new Error('remove_unconfirmed');
        clearRemovedPendingPurchase(link.dataset.requestId, cart);
        window.location.href = ROOT + '/cart';
      }).catch(function () {
        message(L('cart_remove_unconfirmed'));
        busy = false;
      });
    });
  }

  /* ————— pricing ————— */

  function area() {
    // integer centimetres first: (6.25 × 1.12) is 7.000000000000001 in floats and ceil() made it 8 m²
    return (state.wcm * state.hcm) / 10000;
  }

  function currentVariant() {
    var checked = els.materials.querySelector('input[name="material"]:checked');
    if (!checked) return null;
    var id = Number(checked.value);
    var variant = state.product && state.product.variants.filter(function (v) { return Number(v.id) === id; })[0];
    if (!variant || variant.available === false || (checked.disabled && !purchaseInFlight)) return null;
    return { id: id, price: Number(variant.price) };
  }

  function updatePrice() {
    var v = currentVariant();
    var a = area();
    var billable = Math.ceil(a);
    var valid = inRange(state.wcm, state.hcm);
    // a dimension error goes away as soon as the measures are valid again (not only on the next « add to cart »)
    if (valid && els.cartError && !els.cartError.hidden && Number.isInteger(state.wcm) && Number.isInteger(state.hcm)) els.cartError.hidden = true;
    if (v && a > 0 && valid) {
      els.totalPrice.textContent = money(v.price * billable);
      if (els.pdDims) els.pdDims.textContent = fmt('dims_m', { w: meters.format(state.wcm / 100), h: meters.format(state.hcm / 100) });
      if (els.pdArea) els.pdArea.textContent = fmt('area_billed', { n: billable });
      if (els.pdRate) els.pdRate.textContent = fmt('pd_rate', { price: money(v.price) });
    } else {
      els.totalPrice.textContent = '—';
      if (els.pdDims) els.pdDims.textContent = '—';
      if (els.pdArea) els.pdArea.textContent = '—';
      if (els.pdRate) els.pdRate.textContent = '—';
    }
    els.dimW.textContent = fmt('len_m', { n: meters.format(state.wcm / 100) });
    els.dimH.textContent = fmt('len_m', { n: meters.format(state.hcm / 100) });
    var sp = document.getElementById('stickyPrice');
    if (sp) sp.textContent = els.totalPrice.textContent;
  }

  /* ————— cropper ————— */

  function applyAspect() {
    if (!state.cropper || !state.wcm || !state.hcm) return;
    var ratio = state.wcm / state.hcm;
    state.cropper.setAspectRatio(ratio);
    var cv = state.cropper.getCanvasData();
    if (!cv.width) return;
    var bw = cv.width, bh = bw / ratio;
    if (bh > cv.height) { bh = cv.height; bw = bh * ratio; }
    state.cropper.setCropBoxData({
      left: cv.left + (cv.width - bw) / 2,
      top: cv.top + (cv.height - bh) / 2,
      width: bw,
      height: bh
    });
  }

  function resizeCropperPreservingSelection() {
    var cropper = state.cropper;
    if (!cropper || !cropper.ready || cropper.disabled || typeof cropper.resize !== 'function') return;
    var container = cropper.container;
    var previous = cropper.getContainerData();
    if (!container || !container.offsetWidth || !container.offsetHeight ||
        (Math.abs(container.offsetWidth - previous.width) < 0.5 && Math.abs(container.offsetHeight - previous.height) < 0.5)) return;
    var selected = cropper.getData();
    if (!(selected.width > 0 && selected.height > 0)) return;
    // Cropper 1.6 scales screen coordinates on resize, then clamps them. A
    // breakpoint can therefore change the actual print crop. Preserve natural
    // pixels instead and release the old crop-box minimum before refitting.
    cropper.clear();
    cropper.resize();
    cropper.crop();
    cropper.setData(selected);
    layoutFull();
  }

  var cropperRetries = 0;
  var cropperResizeObserver = null;
  var scheduleCropperResize = debounce(resizeCropperPreservingSelection, 80);

  function observeCropperSize() {
    if (cropperResizeObserver) cropperResizeObserver.disconnect();
    cropperResizeObserver = null;
    if (window.ResizeObserver && state.cropper && state.cropper.container) {
      cropperResizeObserver = new window.ResizeObserver(scheduleCropperResize);
      cropperResizeObserver.observe(state.cropper.container);
    }
  }

  function initCropper() {
    if (typeof Cropper === 'undefined') {
      cropperRetries += 1;
      if (cropperRetries > 80) { showError(L('cropper_load_failed')); return; }
      setTimeout(initCropper, 150);
      return;
    }
    cropperRetries = 0;
    if (cropperResizeObserver) cropperResizeObserver.disconnect();
    if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
    state.cropper = new Cropper(els.cropImg, {
      viewMode: 1,
      dragMode: 'move',
      autoCropArea: 1,
      background: false,
      zoomOnWheel: true,
      responsive: false,
      restore: false,
      // the crop box mirrors the wall measures: never freely resizable —
      // change the W×H inputs (or a ratio preset) to change its shape
      cropBoxResizable: false,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: false,
      ready: function () {
        applyAspect();
        applyMirror();
        observeCropperSize();
        var stage = document.querySelector('.stage');
        if (stage) stage.classList.remove('is-loading');
      }
    });
  }

  function mirrored() {
    return !!(els.mirrorMode && els.mirrorMode.checked);
  }

  // :has() fallback for older iOS Safari — mirror + selected material states
  function syncCheckedClasses() {
    if (!els.materials) return;
    els.materials.querySelectorAll('.mseg, .mat-card').forEach(function (l) {
      var input = l.querySelector('input');
      l.classList.toggle('is-checked', !!(input && input.checked));
    });
    var fm = document.getElementById('fullMode');
    if (fm) fm.closest('.tool-mirror').classList.toggle('is-checked', fm.checked);
    if (!els.mirrorMode) return;
    var mw = els.mirrorMode.closest('.tool-mirror');
    if (mw) mw.classList.toggle('is-checked', els.mirrorMode.checked);
  }

  function applyMirror() {
    syncCheckedClasses();
    layoutFull();
    if (!state.cropper) return;
    state.cropper.scaleX(mirrored() ? -1 : 1);
  }

  if (els.mirrorMode) els.mirrorMode.addEventListener('change', applyMirror);

  // minimizable floating bars (tools / ratio presets)
  [['tbToggle', '.stage-toolbar'], ['rbToggle', '.ratio-bar']].forEach(function (pair) {
    var btn = document.getElementById(pair[0]);
    if (!btn) return;
    btn.addEventListener('click', function () {
      btn.closest(pair[1]).classList.toggle('is-min');
    });
  });

  if (HAS_TOOL) {
  window.addEventListener('resize', scheduleCropperResize);
  window.addEventListener('orientationchange', scheduleCropperResize);
  els.zoomIn.addEventListener('click', function () { if (state.cropper) state.cropper.zoom(0.1); });
  els.zoomOut.addEventListener('click', function () { if (state.cropper) state.cropper.zoom(-0.1); });
  els.toolReset.addEventListener('click', function () {
    if (!state.cropper) return;
    state.cropper.reset();
    applyAspect();
    applyMirror();
  });
  }

  /* ————— ratio presets ————— */

  var ratioBtns = Array.prototype.slice.call(document.querySelectorAll('.ratio'));

  function markRatio(val) {
    ratioBtns.forEach(function (b) { b.classList.toggle('is-on', b.dataset.ratio === val); });
  }

  ratioBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var r = b.dataset.ratio;
      markRatio(r);
      if (r === 'custom') return;
      var parts = r.split(':');
      var rw = parseFloat(parts[0]), rh = parseFloat(parts[1]);
      var newH = Math.round(state.wcm * rh / rw);
      if (newH < LIM.minH || newH > LIM.maxH) {
        newH = Math.min(LIM.maxH, Math.max(LIM.minH, newH));
        state.wcm = Math.round(newH * rw / rh);
      }
      state.hcm = newH;
      showDims();          // the inputs show the unit the customer chose (cm or inches)
      updatePrice();
      applyAspect();
      layoutFull();
    });
  });

  /* ————— hydration / routing ————— */

  // same copy as the Liquid cards in sections/atelier.liquid (atelier.materials.*; supplier specs, 2026-10-28)
  var MAT = {
    prem: { name: L('mat_prem_name'), badge: L('mat_prem_badge'), desc: L('mat_prem_desc'),
      feats: [L('mat_prem_feat_1'), L('mat_prem_feat_2'), L('mat_prem_feat_3'), L('mat_prem_feat_4')] },
    adh: { name: L('mat_adh_name'), badge: L('mat_adh_badge'), desc: L('mat_adh_desc'),
      feats: [L('mat_adh_feat_1'), L('mat_adh_feat_2'), L('mat_adh_feat_3'), L('mat_adh_feat_4')] }
  };
  // a title without the catalogue's generic word (locale key general.title_strip, as snippets/collection-name)
  function stripTitle(t) {
    var out = String(t || '');
    String(SHOP.titleStrip || '').split('|').forEach(function (w) { w = w.trim(); if (w) out = out.split(w).join(''); });
    return out.trim();
  }

  function renderMaterials(product) {
    var base = product.variants.length
      ? Math.min.apply(null, product.variants.map(function (v) { return v.price; })) : 0;
    var html = '<legend class="visually-hidden">' + esc(L('material_legend')) + '</legend>';
    var selected = false;
    product.variants.forEach(function (v) {
      var available = v.available !== false;
      var checked = available && !selected;
      if (checked) selected = true;
      // material = SKU suffix (titles are translated); a SKU without either suffix: the dearer variant is the
      // adhesive one and the card keeps the variant title — same rule as the Liquid cards
      var adh = skuEnds(v.sku, SHOP.skuAdhesive), known = adh || skuEnds(v.sku, SHOP.skuPremium);
      if (!known) adh = v.price > base;
      var name = known ? (adh ? MAT.adh.name : MAT.prem.name) : stripTitle(v.title);
      var extra = v.price > base ? ' <small>' + esc(fmt('rate_extra_per_m2', { price: money(v.price - base) })) + '</small>' : '';
      html += '<label class="mat-card">' +
        '<input type="radio" name="material" value="' + v.id + '" data-price="' + v.price + '"' + (checked ? ' checked' : '') + (available ? '' : ' disabled') + '>' +
        '<span class="mat-badge">' + esc(adh ? MAT.adh.badge : MAT.prem.badge) + '</span>' +
        '<span class="mat-name">' + esc(available ? name : fmt('mat_name_unavailable', { name: name })) + '</span>' +
        '<span class="mat-rate">' + esc(fmt('rate_per_m2', { price: money(v.price) })) + extra + '</span>' +
        '<span class="mat-desc">' + esc(adh ? MAT.adh.desc : MAT.prem.desc) + '</span>' +
        '<ul class="mat-feats">' + (adh ? MAT.adh.feats : MAT.prem.feats).map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul>' +
        '</label>';
    });
    els.materials.innerHTML = html;
    syncCheckedClasses();
  }

  function renderMockups(product) {
    // media gallery: the FIRST room shot fills the big viewer, every image
    // (design included, last) is a thumb; clicking a thumb swaps the viewer
    state.mockupList = product.images.slice();
    state.mediaIdx = 0;
    var main = document.getElementById('mediaMainImg');
    if (main) {
      main.src = sized(product.images[0], 1200);
      main.alt = fmt('media_main_alt', { title: product.title });
    }
    els.mockups.innerHTML = product.images.map(function (src, i) {
      return '<button type="button" class="media-thumb' + (i === 0 ? ' is-on' : '') + '" data-full="' + esc(src) + '" data-idx="' + i + '" aria-label="' + esc(fmt('thumb_label', { n: i + 1 })) + '">' +
        '<img src="' + esc(sized(src, 300)) + '" alt="" decoding="async" width="150" height="112"></button>';
    }).join('');
  }

  function hydrate(product, opts) {
    opts = opts || {};
    state.product = product;
    state.cache[product.handle] = product;
    document.dispatchEvent(new CustomEvent('mpp-atelier:product', {detail:{id:String(product.id),title:product.title}}));

    els.pTitle.textContent = product.title;
    els.pType.textContent = product.type || L('type_default');

    if (product.description != null) {
      els.pDesc.innerHTML = product.description;
    } else {
      els.pDesc.innerHTML = '<p>…</p>';
      fetch(ROOT + '/products/' + product.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (raw) {
          if (state.product && state.product.handle === product.handle) {
            product.description = raw.description || '';
            els.pDesc.innerHTML = product.description;
          }
        })
        .catch(function () {});
    }

    renderMaterials(product);
    renderMockups(product);

    // design image → cropper. Display a lighter 1600px rendition when the
    // design's natural width is known; the ORIGIN sent to the crop API stays
    // the full-size URL and coords are scaled up in purchase().
    var design = product.images[product.images.length - 1];
    var stage = document.querySelector('.stage');
    if (stage) stage.classList.add('is-loading');
    if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
    els.cropImg.onload = function () { initCropper(); layoutFull(); };
    els.cropImg.src = product.designW ? sized(design, 1600) : design;
    els.cropImg.alt = fmt('crop_img_alt', { title: product.title });

    updatePrice();
    highlightCard(product.handle);

    if (opts.push) {
      history.pushState({ handle: product.handle }, '', product.url);
    }
    document.title = product.title + (CFG.brand ? ' — ' + CFG.brand : '');

    if (opts.scroll) {
      document.getElementById('studio').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function highlightCard(handle) {
    els.grid.querySelectorAll('.card').forEach(function (c) {
      c.classList.toggle('is-selected', c.dataset.handle === handle);
    });
  }

  function selectByHandle(handle, opts) {
    state.creation = null;      // a customer's creation only belongs to its own page
    if (state.cache[handle]) { hydrate(state.cache[handle], opts); return; }
    fetch(ROOT + '/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (raw) { hydrate(normProduct(raw), opts); })
      .catch(function () { toast(L('product_not_found')); });
  }

  window.addEventListener('popstate', function (e) {
    if (!HAS_TOOL) return;
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    var handle = m ? m[1] : (e.state && e.state.handle) || state.entryHandle;
    if (handle) selectByHandle(handle, { push: false });
  });

  /* ————— favorites ————— */

  var LS_FAVS = 'atelier_favs';

  function favs() { return lsJSON(LS_FAVS, []); }

  function isFav(handle) {
    return favs().some(function (p) { return p.handle === handle; });
  }

  function cacheFromCard(handle) {
    var link = els.grid.querySelector('.card[data-handle="' + handle + '"] .card-link');
    if (link && link.dataset.payload) {
      try {
        var p = normProduct(JSON.parse(link.dataset.payload));
        state.cache[handle] = p;
        return p;
      } catch (e) {}
    }
    return null;
  }

  function toggleFav(handle) {
    var list = favs();
    var i = list.findIndex(function (p) { return p.handle === handle; });
    if (i > -1) {
      list.splice(i, 1);
      toast(L('fav_removed'));
    } else {
      var p = state.cache[handle] || cacheFromCard(handle);
      if (!p) return;
      list.unshift(slim(p));
      toast(L('fav_added'));
    }
    lsSet(LS_FAVS, JSON.stringify(list));
    syncFavUI();
    if (state.favMode) showFavorites();
  }

  function syncFavUI() {
    var n = favs().length;
    if (els.favCount) {
      els.favCount.textContent = n;
      els.favCount.hidden = n === 0;
    }
    els.grid.querySelectorAll('.card-fav').forEach(function (b) {
      b.classList.toggle('is-on', isFav(b.dataset.fav));
    });
  }

  // a snapshot taken in another language or currency (or before snapshots were tagged) is stale
  function freshFav(f) { return f && f.locale === LOCALE && f.currency === CURRENCY; }

  function refreshFav(handle) {
    fetch(ROOT + '/products/' + handle + '.js')
      .then(function (r) { if (r.status === 404) return null; if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (raw) {
        var list = favs(), i = list.findIndex(function (f) { return f.handle === handle; });
        if (i < 0) return;
        if (!raw) { list.splice(i, 1); } else {     // archived or deleted: dropped
          var p = normProduct(raw);
          p.url = ROOT + '/products/' + p.handle;
          list[i] = slim(p);
          if (!state.cache[p.handle]) state.cache[p.handle] = p;
        }
        lsSet(LS_FAVS, JSON.stringify(list));
        syncFavUI();
        if (state.favMode) renderFavorites();
      })
      .catch(function () {});
  }

  function renderFavorites() {
    // fresh data first (SSR / fetched cache), else this language's snapshot; a stale snapshot shows at once
    // and is refreshed (only validated entries enter the cache, so selecting a stale one fetches it)
    var products = favs().map(function (f) {
      if (state.cache[f.handle]) return state.cache[f.handle];
      var p = normProduct(f);
      if (freshFav(f)) state.cache[p.handle] = p; else refreshFav(f.handle);
      return p;
    });
    els.grid.innerHTML = products.length
      ? products.map(cardHTML).join('')
      : '<p class="empty-note">' + esc(L('fav_empty')) + '</p>';
    highlightCard(state.product ? state.product.handle : '');
    syncFavUI();
  }

  function showFavorites() {
    state.favMode = true;
    els.exploreTitle.textContent = L('fav_title');
    els.exploreBack.hidden = false;
    els.gridMore.hidden = true;
    if (els.gridStatus) els.gridStatus.textContent = '';
    renderFavorites();
    document.querySelector('.related').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function backToBrowse() {
    state.favMode = false;
    els.exploreBack.hidden = true;
    els.exploreTitle.textContent = state.chipTitle;
    els.gridMore.hidden = true;
    state.autoLeft = AUTO_PAGES;
    loadCollection(state.chip, 1, false);
  }

  els.favBtn.addEventListener('click', showFavorites);
  els.exploreBack.addEventListener('click', backToBrowse);

  /* ————— showroom: tiles + carousel ————— */

  function cardHTML(p) {
    var design = p.images[p.images.length - 1] || '';
    var from = p.variants.length ? Math.min.apply(null, p.variants.map(function (v) { return v.price; })) : 0;
    var short = p.title;
    return '<article class="card" data-handle="' + esc(p.handle) + '">' +
      '<a class="card-link" href="' + esc(p.url) + '">' +
      '<span class="card-media"><img src="' + esc(sized(design, 640)) + '" alt="' + esc(p.title) + '" loading="lazy" width="640" height="480">' +
      '<span class="card-check" aria-hidden="true"><svg viewBox="0 0 24 24" width="13" height="13"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '</span>' +
      '<span class="card-body"><span class="card-title">' + esc(short) + '</span>' +
      '<span class="card-price">' + esc(fmt('card_price_from', { price: money(from) })) + '</span></span>' +
      '</a>' +
      '<button class="card-fav" type="button" aria-label="' + esc(L('fav_add_label')) + '" data-fav="' + esc(p.handle) + '">' +
      '<svg viewBox="0 0 24 24" width="15" height="15"><path d="M12 20.5l-1.3-1.2C6 15.2 3 12.5 3 9.2 3 6.5 5.1 4.5 7.8 4.5c1.5 0 3 .7 4.2 2 1.2-1.3 2.7-2 4.2-2 2.7 0 4.8 2 4.8 4.7 0 3.3-3 6-7.7 10.1L12 20.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '</article>';
  }

  /* ————— related grid: SSR page N + SEO-safe infinite scroll ————— */

  var PER_PAGE = CFG.perPage || 24;
  // auto-loads per arming (collection template only); 0 = button only
  var AUTO_PAGES = CFG.template === 'collection' ? (CFG.autoPages == null ? 3 : CFG.autoPages) : 0;
  // the address bar reflects the page only while it still shows the collection (SPA select pushes /products/<h>)
  var COLLECTION_PATH = CFG.template === 'collection' ? (CFG.explorerUrl || location.pathname) : null;
  var AUTO_MARGIN = 900; // px before the sentinel enters the viewport (≈ 1 screen, clears the mobile sticky CTA)
  // « … – Page 2 — Brand »: same shape as the SSR title of ?page=N (layout: ' – ' + general.meta.page);
  // js.atelier.title_page must keep the same text as general.meta.page in every language
  var PAGE_RE = new RegExp(' – ' + L('title_page').replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace('\\{n\\}', '\\d+'));

  function hasMore() { return state.page < state.pages; }

  function gridHandles() {
    var set = {};
    els.grid.querySelectorAll('.card').forEach(function (c) { set[c.dataset.handle] = 1; });
    return set;
  }

  function skeletonHTML(n) {
    var s = '';
    for (var i = 0; i < n; i++) {
      s += '<div class="card is-skeleton" aria-hidden="true"><span class="card-media"></span>' +
        '<span class="card-body"><span class="sk-line"></span><span class="sk-line sk-short"></span></span></div>';
    }
    return s;
  }
  function clearSkeletons() {
    els.grid.querySelectorAll('.card.is-skeleton').forEach(function (n) { n.remove(); });
  }

  function pageURL(n) {
    var u = new URL(location.href);
    if (n > 1) u.searchParams.set('page', n); else u.searchParams.delete('page');
    return u.pathname + u.search;
  }

  // Google lazy-loading guidance: reflect the visible page with the History API — replaceState, never pushState
  function reflectPage(n) {
    if (!COLLECTION_PATH || state.favMode || location.pathname !== COLLECTION_PATH) return;
    var cur = parseInt(new URL(location.href).searchParams.get('page') || '1', 10);
    if (cur === n) return;
    history.replaceState(Object.assign({}, history.state || {}, { page: n }), '', pageURL(n));
    var base = (state.baseTitle || document.title).replace(PAGE_RE, '');
    var i = base.lastIndexOf(' — ');
    document.title = (n > 1 && i > -1) ? base.slice(0, i) + ' – ' + fmt('title_page', { n: n }) + base.slice(i) : base;
    if (els.pagiCur) els.pagiCur.textContent = n;
  }

  // the page whose first card sits above 40 % of the viewport is "the page you are on"
  function pageOnScreen() {
    var cur = state.firstPage, line = window.innerHeight * 0.4;
    els.grid.querySelectorAll('.card[data-page]').forEach(function (m) {
      if (m.getBoundingClientRect().top <= line) cur = parseInt(m.dataset.page, 10) || cur;
    });
    return cur;
  }
  var reflectQueued = false;
  function onScrollReflect() {
    if (reflectQueued) return;
    reflectQueued = true;
    requestAnimationFrame(function () { reflectQueued = false; reflectPage(pageOnScreen()); });
  }

  function updateGridStatus() {
    var shown = els.grid.querySelectorAll('.card:not(.is-skeleton)').length;
    var total = state.total || shown;
    if (els.gridCount) els.gridCount.textContent = P('grid_count', total);
    if (els.gridStatus) {
      els.gridStatus.textContent = state.favMode ? ''
        : hasMore() ? fmt('grid_shown', { shown: shown, total: total })
        : total > PER_PAGE ? fmt('grid_seen_all', { total: total }) : '';
    }
    els.moreBtn.textContent = hasMore() ? fmt('more_btn_count', { shown: shown, total: total }) : L('more_btn');
    els.gridMore.hidden = state.favMode || !hasMore() || (!!state.io && state.autoLeft > 0);
    if (els.pagiNext) {
      els.pagiNext.hidden = !hasMore();
      if (hasMore()) els.pagiNext.href = pageURL(state.page + 1);
    }
  }

  function loadCollection(handle, page, append) {
    if (state.busy) return;
    state.busy = true;
    els.moreBtn.disabled = true;
    els.moreBtn.textContent = L('loading');
    if (append) els.grid.insertAdjacentHTML('beforeend', skeletonHTML(8));
    // the Liquid view templates/collection.cards.liquid (translated titles, prices in the visitor's currency);
    // never /products.json, which is the shop's base currency and untranslated
    fetch(ROOT + '/collections/' + handle + '?view=cards&page=' + page)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        clearSkeletons();
        var got = (data.products || []).length;
        var seen = append ? gridHandles() : {};
        // best-selling order can shift between the SSR render and this fetch: never show a card twice
        var products = (data.products || []).map(normProduct).filter(function (p) {
          if (seen[p.handle]) return false;
          seen[p.handle] = 1;
          return true;
        });
        products.forEach(function (p) { state.cache[p.handle] = p; });
        var html = products.map(cardHTML).join('');
        if (append) {
          els.grid.insertAdjacentHTML('beforeend', html);
        } else {
          els.grid.innerHTML = html || '<p class="empty-note">' + esc(L('collection_empty')) + '</p>';
          state.firstPage = 1;
        }
        if (products.length) {
          var cards = els.grid.querySelectorAll('.card:not(.is-skeleton)');
          cards[cards.length - products.length].dataset.page = page; // page marker = first card of the batch
        }
        if (got) state.page = page;                              // only advance on success
        if (got < PER_PAGE) state.pages = got ? page : page - 1; // server says: nothing after this
        highlightCard(state.product ? state.product.handle : '');
        syncFavUI();
        if (!append) reflectPage(1);
      })
      .catch(function () {
        clearSkeletons();
        state.autoLeft = 0; // stop the auto-loader: the button becomes the retry
        toast(L('collection_load_failed'));
      })
      .finally(function () {
        state.busy = false;
        els.moreBtn.disabled = false;
        updateGridStatus();
        maybeChain();
      });
  }

  // sentinel under the grid: within AUTO_MARGIN of the viewport → fetch the next page (AUTO_PAGES in a row)
  function armAutoLoad() {
    if (state.io || !els.gridSentinel || AUTO_PAGES <= 0 || !('IntersectionObserver' in window)) return;
    state.io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) autoLoad();
    }, { rootMargin: '0px 0px ' + AUTO_MARGIN + 'px 0px' });
    state.io.observe(els.gridSentinel);
  }
  function autoLoad() {
    if (state.favMode || state.busy || !hasMore() || state.autoLeft <= 0) return;
    state.autoLeft--;
    loadCollection(state.chip, state.page + 1, true);
  }
  // tall viewports: 24 cards may not push the sentinel off-screen → keep going without a scroll event
  function maybeChain() {
    if (!state.io || state.busy || !hasMore() || state.autoLeft <= 0) return;
    if (els.gridSentinel.getBoundingClientRect().top < window.innerHeight + AUTO_MARGIN) autoLoad();
  }
  // arm on the first user gesture only: crawlers don't scroll/click → their rendered DOM is the pure SSR page
  function armOnInteraction() {
    if (AUTO_PAGES <= 0 || !els.gridSentinel) return;
    var types = ['scroll', 'wheel', 'touchmove', 'keydown'];
    var arm = function () {
      types.forEach(function (t) { window.removeEventListener(t, arm); });
      armAutoLoad();
      updateGridStatus();
      maybeChain();
    };
    types.forEach(function (t) { window.addEventListener(t, arm, { passive: true }); });
  }

  // collection tiles are plain links: each collection has its own branded page

  els.moreBtn.addEventListener('click', function () {
    state.autoLeft = AUTO_PAGES; // re-arm the auto-loader for the next batches
    loadCollection(state.chip, state.page + 1, true);
  });

  // click on any card (server- or client-rendered) → select without reload
  els.grid.addEventListener('click', function (e) {
    var fav = e.target.closest('.card-fav');
    if (fav) {
      e.preventDefault();
      toggleFav(fav.dataset.fav);
      return;
    }
    var link = e.target.closest('.card-link');
    if (!link) return;
    if (!HAS_TOOL) return; // no configurator here — follow the link to the product page
    e.preventDefault();
    var card = link.closest('.card');
    var payload = link.dataset.payload;
    if (payload) {
      try {
        var p = normProduct(JSON.parse(payload));
        hydrate(p, { push: true, scroll: true });
        return;
      } catch (err) { /* fall through */ }
    }
    selectByHandle(card.dataset.handle, { push: true, scroll: true });
  });

  /* ————— dimensions ————— */

  function inputCm(el) {
    var v = parseFloat(String(el.value).replace(',', '.')) || 0;
    return state.unit === 'in' ? Math.round(v * 2.54) : v;
  }
  function onDims() {
    var w = inputCm(els.wInput);
    var h = inputCm(els.hInput);
    var changed = w !== state.wcm || h !== state.hcm;
    state.wcm = w;
    state.hcm = h;
    markRatio('custom');
    updatePrice();
    // A pending input debounce must not recenter a crop already accepted at checkout.
    if (changed) applyAspect();
    var conv = document.getElementById('unitConv');
    if (conv) { conv.hidden = state.unit !== 'in'; conv.textContent = fmt('unit_conv', { w: state.wcm, h: state.hcm }); }
    layoutFull();
  }

  /* ————— units, whole design, effects ————— */
  var IN = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 });
  function showDims() {
    var toIn = function (cm) { return Math.round(cm / 2.54 * 10) / 10; };
    els.wInput.value = state.wcm ? (state.unit === 'in' ? toIn(state.wcm) : state.wcm) : '';
    els.hInput.value = state.hcm ? (state.unit === 'in' ? toIn(state.hcm) : state.hcm) : '';
    var conv = document.getElementById('unitConv');
    if (conv) { conv.hidden = state.unit !== 'in'; conv.textContent = fmt('unit_conv', { w: state.wcm, h: state.hcm }); }
  }
  function setUnit(unit) {
    if (unit === state.unit) return;
    onDims();            // commit what was just typed (a debounce may still be pending) in the old unit
    state.unit = unit;
    document.querySelectorAll('.unit-opt').forEach(function (b) { var on = b.dataset.unit === unit; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    document.querySelectorAll('[data-unit-label]').forEach(function (u) { u.textContent = unit === 'in' ? L('unit_in') : L('unit_cm'); });
    // inch bounds from the cm limits (100 cm → 39.4 in; 3000 cm → 1181 in)
    var inMin = function (cm) { return Math.round(cm / 2.54 * 10) / 10; }, inMax = function (cm) { return Math.round(cm / 2.54); };
    if (unit === 'in') {
      els.wInput.min = inMin(LIM.minW); els.wInput.max = inMax(LIM.maxW); els.wInput.step = 0.1;
      els.hInput.min = inMin(LIM.minH); els.hInput.max = inMax(LIM.maxH); els.hInput.step = 0.1;
    } else {
      els.wInput.min = LIM.minW; els.wInput.max = LIM.maxW; els.wInput.step = 1; els.hInput.min = LIM.minH; els.hInput.max = LIM.maxH; els.hInput.step = 1;
    }
    showDims();
    onDims();
  }
  document.querySelectorAll('.unit-opt').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.unit); }); });

  var fullModeEl = document.getElementById('fullMode');
  var fullFrame = document.getElementById('fullFrame'), fullImg = document.getElementById('fullImg'), fullNote = document.getElementById('fullNote');
  function layoutFull() {
    var stage = els.cropImg && els.cropImg.closest('.stage');
    if (!stage || !fullFrame) return;
    var on = state.fit === 'full';
    stage.classList.toggle('is-full', on);
    fullFrame.hidden = !on; if (fullNote) fullNote.hidden = !on;
    if (!on || !state.wcm || !state.hcm) return;
    var src = els.cropImg.currentSrc || els.cropImg.src;
    if (fullImg.getAttribute('src') !== src) fullImg.src = src;
    var box = fullFrame.getBoundingClientRect();
    var r = state.wcm / state.hcm, bw = Math.max(40, box.width - 28), bh = Math.max(40, box.height - 28);
    var w = Math.min(bw, bh * r);
    fullImg.style.width = Math.round(w) + 'px';
    fullImg.style.height = Math.round(w / r) + 'px';
    fullImg.style.transform = mirrored() ? 'scaleX(-1)' : '';
  }
  if (fullModeEl && fullModeEl.checked) { state.fit = 'full'; syncCheckedClasses(); }   // restored by the browser
  if (fullModeEl) fullModeEl.addEventListener('change', function () {
    state.fit = fullModeEl.checked ? 'full' : 'crop';
    syncCheckedClasses(); layoutFull();
  });
  document.querySelectorAll('.fx').forEach(function (b) {
    b.addEventListener('click', function () {
      state.effect = b.dataset.effect;
      document.querySelectorAll('.fx').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      var stage = els.cropImg && els.cropImg.closest('.stage'); if (stage) stage.dataset.effect = state.effect;
    });
  });
  window.addEventListener('resize', function () { if (state.fit === 'full') layoutFull(); });
  var FX_LABEL = { bw: L('fx_bw'), sepia: L('fx_sepia') };   // display only
  // stored cart properties (names and values) stay French whatever the shop language — the order contract
  // (docs/i18n.md); renderDrawer() and templates/cart.liquid translate them at display time only
  var FX_PROP = { bw: 'Noir et blanc', sepia: 'Sépia' };
  var FIT_FULL_PROP = 'Décor entier, adapté aux proportions du mur';
  var TYPED_UNIT_PROP = ' pouces';
  var PROP_LABEL = { 'Cadrage': 'prop_fit', 'Effet': 'prop_effect', 'Mesures saisies': 'prop_typed' };
  function propValue(v) {
    if (v === FIT_FULL_PROP) return L('fit_full');
    if (v === FX_PROP.bw) return L('fx_bw');
    if (v === FX_PROP.sepia) return L('fx_sepia');
    return String(v).replace(TYPED_UNIT_PROP, ' ' + L('unit_in_long'));
  }
  if (HAS_TOOL) {
    els.wInput.addEventListener('input', debounce(onDims, 250));
    els.hInput.addEventListener('input', debounce(onDims, 250));
    els.materials.addEventListener('change', function () {
      updatePrice();
      syncCheckedClasses();
    });
  }

  /* ————— search ————— */

  var doSearch = debounce(function () {
    var q = els.searchInput.value.trim();
    if (q.length < 2) { els.searchResults.hidden = true; return; }
    fetch(ROOT + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (((data || {}).resources || {}).results || {}).products || [];
        if (!prods.length) {
          els.searchResults.innerHTML = '<p class="sr-empty">' + esc(L('search_empty')) + '</p>';
        } else {
          els.searchResults.innerHTML = prods.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            return '<button type="button" class="sr-item" data-handle="' + esc(p.handle) + '">' +
              (img ? '<img src="' + esc(sized(img, 120)) + '" alt="">' : '') +
              '<span>' + esc(p.title) + '</span></button>';
          }).join('');
        }
        els.searchResults.hidden = false;
      })
      .catch(function () {});
  }, 220);

  els.searchInput.addEventListener('input', doSearch);
  els.searchInput.addEventListener('focus', doSearch);
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#searchBox')) els.searchResults.hidden = true;
  });
  els.searchResults.addEventListener('click', function (e) {
    var item = e.target.closest('.sr-item');
    if (!item) return;
    els.searchResults.hidden = true;
    els.searchInput.value = '';
    if (!HAS_TOOL) { location.href = ROOT + '/products/' + item.dataset.handle; return; }
    selectByHandle(item.dataset.handle, { push: true, scroll: true });
  });

  /* ————— add to cart / buy now ————— */

  function showError(msg) {
    els.cartError.textContent = msg;
    els.cartError.hidden = false;
  }

  function validateDims() {
    els.cartError.hidden = true;
    if (!Number.isFinite(state.wcm) || !Number.isFinite(state.hcm) || !state.wcm || !state.hcm) { showError(L('dims_missing')); return false; }
    if (!Number.isInteger(state.wcm) || !Number.isInteger(state.hcm)) { showError(L('dims_integer')); return false; }
    if (state.wcm < LIM.minW || state.wcm > LIM.maxW) { showError(fmt('width_range', { min: LIM.minW, max: num.format(LIM.maxW / 100) })); return false; }
    if (state.hcm < LIM.minH || state.hcm > LIM.maxH) { showError(fmt('height_range', { min: LIM.minH, max: num.format(LIM.maxH / 100) })); return false; }
    return true;
  }

  // the user's crop selection scaled to the full-size origin image and
  // clamped to [0, natural] — shared by purchase() and the wall preview
  function cropRegion() {
    if (!state.cropper || !state.product) return null;
    var crop = state.cropper.getData();
    var originUrl = state.product.images[state.product.images.length - 1];
    // exact full-size dims from Liquid (CDN caps width at 5760, height scales)
    var fullW = state.product.designW || 0, fullH = state.product.designH || 0;
    if (fullW > 5760) { fullH = Math.round(fullH * 5760 / fullW); fullW = 5760; }
    var nw = fullW || els.cropImg.naturalWidth;
    var nh = fullH || els.cropImg.naturalHeight;
    var scale = els.cropImg.naturalWidth ? nw / els.cropImg.naturalWidth : 1;
    crop.x *= scale; crop.y *= scale; crop.width *= scale; crop.height *= scale;
    var cx = Math.min(Math.max(0, crop.x), nw - 1);
    var cy = Math.min(Math.max(0, crop.y), nh - 1);
    var cw = Math.max(1, Math.min(crop.width, nw - cx));
    var ch = Math.max(1, Math.min(crop.height, nh - cy));
    return {
      originUrl: originUrl,
      mirror: !!(els.mirrorMode && els.mirrorMode.checked),
      x: Math.round(cx * 100) / 100,
      y: Math.round(cy * 100) / 100,
      w: Math.round(cw * 100) / 100,
      h: Math.round(ch * 100) / 100
    };
  }

  // Shopify AJAX has no application idempotency-key contract. Give each attempted
  // addition a distinct private line property, persist before POST, and reconcile
  // a lost/invalid response by GET only. Never replay an uncertain add request.
  /* Wall preview through the assistant: project the customer's exact selection (papercrop, mirror
     included), exactly what will be printed. A failed crop falls back to the whole design. */
  /* The customer's framing, rendered in the browser exactly as configured — crop box (cropper.js
     applies the mirror), or the whole design stretched to the wall ratio — plus the colour effect.
     Used for the wall preview only (the print file still comes from papercrop at purchase). */
  function framedDesign(maxSide, quality) {
    return new Promise(function (resolve) {
      try {
        if (!state.wcm || !state.hcm || !state.cropper || !state.cropper.ready) return resolve(null);
        var expected = state.product && state.product.images[state.product.images.length - 1];
        if (!els.cropImg.complete || !els.cropImg.naturalWidth || (expected && els.cropImg.src.split('?')[0] !== sized(expected, 1600).split('?')[0] && els.cropImg.src.split('?')[0] !== expected.split('?')[0])) return resolve(null);
        var src, w, h, whole = state.fit === 'full';
        if (whole) {
          var r = state.wcm / state.hcm;
          w = r >= 1 ? maxSide : Math.round(maxSide * r); h = r >= 1 ? Math.round(maxSide / r) : maxSide; src = els.cropImg;
        } else {
          src = state.cropper && state.cropper.getCroppedCanvas({ maxWidth: maxSide, maxHeight: maxSide, imageSmoothingQuality: 'high' });
          if (!src) return resolve(null);
          w = src.width; h = src.height;
        }
        if (!(w >= 16 && h >= 16)) return resolve(null);
        var out = document.createElement('canvas'); out.width = w; out.height = h;
        var ctx = out.getContext('2d');
        if (whole && mirrored()) { ctx.translate(w, 0); ctx.scale(-1, 1); }
        ctx.drawImage(src, 0, 0, w, h);
        applyEffect(ctx, w, h);
        resolve(out.toDataURL('image/jpeg', quality || 0.9));
      } catch (e) { resolve(null); }   // tainted canvas: the preview falls back to the whole design
    });
  }

  function applyEffect(ctx, w, h) {
    if (state.effect === 'none') return;     // pixel ops: canvas filters are not available in every Safari
    var px = ctx.getImageData(0, 0, w, h), d = px.data;
    for (var i = 0; i < d.length; i += 4) {
      var g = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      if (state.effect === 'bw') { d[i] = d[i + 1] = d[i + 2] = g; }
      else { d[i] = Math.min(255, g * 1.07 + 20); d[i + 1] = Math.min(255, g * 0.94 + 8); d[i + 2] = Math.min(255, g * 0.74); }
    }
    ctx.putImageData(px, 0, 0);
  }

  /* ————— framing thumbnail (order emails, cart) —————
     The print file is a full-resolution JPEG, far too heavy for an email and the cart. At add-to-cart the
     framing the print gets (crop, mirror, effect) is rendered here as a small JPEG, uploaded to the assistant
     service (POST /v1/framing) and its URL goes on the cart line as the PRIVATE property `_preview` — the
     underscore hides it from Shopify's checkout, and it is not part of the supplier contract (Width / Height /
     imageURL). Never blocks a purchase: a blank assistant_api, a render or upload failure = the line without it. */
  var FRAMING_URL = CFG.assistantApi ? CFG.assistantApi.replace(/\/+$/, '') + '/v1/framing' : '';
  // theme setting framing_prefix = https://storage.googleapis.com/<public bucket of the assistant>/framings/ : the only place a thumbnail is trusted from
  var FRAMING_PREFIX = /^https:\/\/[A-Za-z0-9._~\/-]+\/$/.test(CFG.framingPrefix || '') ? CFG.framingPrefix : '';
  var THUMB_SIDE = 900, THUMB_QUALITY = 0.82;

  // URL of a stored framing (FRAMING_PREFIX + <2 hex>/<sha256>.jpg), else '' — also the filter of what the cart shows
  function safePreviewURL(value) {
    if (!FRAMING_PREFIX || typeof value !== 'string' || value.length > 300) return '';
    return value.indexOf(FRAMING_PREFIX) === 0 && /^[0-9a-f]{2}\/[0-9a-f]{6,64}\.jpg$/.test(value.slice(FRAMING_PREFIX.length)) ? value : '';
  }

  // data URL of the framing as ordered (ratio 0), or of the centre cut at the sample's ratio (w / h); null if not renderable
  function framingThumbnail(ratio) {
    if (!ratio) return framedDesign(THUMB_SIDE, THUMB_QUALITY);
    return new Promise(function (resolve) {
      try {
        if (!state.cropper || !state.cropper.ready || !els.cropImg.complete || !els.cropImg.naturalWidth) return resolve(null);
        var whole = state.fit === 'full', src, sw, sh;
        if (whole) { src = els.cropImg; sw = els.cropImg.naturalWidth; sh = els.cropImg.naturalHeight; }
        else {
          src = state.cropper.getCroppedCanvas({ maxWidth: THUMB_SIDE * 2, maxHeight: THUMB_SIDE * 2, imageSmoothingQuality: 'high' });
          if (!src) return resolve(null);
          sw = src.width; sh = src.height;
        }
        var cw = sw, ch = sh;                                  // the sample is the centre of the framing, at its ratio
        if (cw / ch > ratio) cw = ch * ratio; else ch = cw / ratio;
        var k = Math.min(1, THUMB_SIDE / Math.max(cw, ch)), w = Math.round(cw * k), h = Math.round(ch * k);
        if (!(w >= 16 && h >= 16)) return resolve(null);
        var out = document.createElement('canvas'); out.width = w; out.height = h;
        var ctx = out.getContext('2d');
        if (whole && mirrored()) { ctx.translate(w, 0); ctx.scale(-1, 1); }
        ctx.drawImage(src, (sw - cw) / 2, (sh - ch) / 2, cw, ch, 0, 0, w, h);
        applyEffect(ctx, w, h);
        resolve(out.toDataURL('image/jpeg', THUMB_QUALITY));
      } catch (e) { resolve(null); }
    });
  }

  // starts now (the framing is read synchronously, before the controls lock) and always resolves: URL or ''
  function uploadFraming(ratio) {
    if (!FRAMING_URL || !FRAMING_PREFIX) return Promise.resolve('');   // nowhere trusted to show it from: no upload
    var thumb;
    try { thumb = framingThumbnail(ratio); } catch (e) { return Promise.resolve(''); }
    return thumb.then(function (data) {
      if (!data) return '';
      return requestJSON(FRAMING_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: data }), timeoutMs: 12000 })
        .then(function (res) { return safePreviewURL(res && res.url); });
    }).catch(function () { return ''; });
  }

  function assistantPreview() {
    if (!state.product) return;
    var design = sized(state.product.images[state.product.images.length - 1], 960);
    var framedP = framedDesign(2048);
    var dims = fmt('dims_cm', { w: state.wcm, h: state.hcm }) + (FX_LABEL[state.effect] ? ' · ' + FX_LABEL[state.effect] : '');
    framedP.then(function (framed) {
      var o = { title: state.product.title, thumb: framed || design, url: state.product.url, framedPromise: framedP,
        choices: {
          framed: { thumb: framed || design, title: state.fit === 'full' ? L('pv_framed_full') : L('pv_framed_crop'), sub: dims,
            disabled: !framed, why: !state.wcm || !state.hcm ? L('pv_need_dims') : L('pv_not_ready') },
          whole: { thumb: design, title: L('pv_whole_title'), sub: L('pv_whole_sub') }
        } };
      if (state.creation) o.creation = state.creation; else o.handle = state.product.handle;
      window.MPPAssistant.preview(o);
    });
  }

  /* Sample of the customer's framing (theme settings sample_*_cm; A4 portrait 21 × 30 for MPP): the centre of
     the crop box at the sample's ratio, cut by papercrop like any print file. Cart line = its size in cm and
     the matching ceil(m²) quantity (1 for an A4), so it passes the mural-line checks. */
  function orderSample(btn) {
    if (!btn.dataset.variant) { toast(fmt('sample_soon', { format_name: CFG.sampleFormat || '' })); return; }
    if (!state.product || !state.cropper) { showError(L('visual_not_ready')); return; }
    var region = cropRegion(); if (!region) return;
    if (state.fit === 'full') {   // whole-design order: sample the centre of the whole design, in cropRegion's pixel space
      var nw = state.product.designW || 0, nh = state.product.designH || 0;
      if (nw > 5760) { nh = Math.round(nh * 5760 / nw); nw = 5760; }
      if (!nw) { nw = els.cropImg.naturalWidth; nh = els.cropImg.naturalHeight; }
      region = Object.assign({}, region, { x: 0, y: 0, w: nw, h: nh });
    }
    var SC = CFG.sampleCm || { w: 21, h: 30 };
    var ratio = SC.w / SC.h, w = region.w, h = region.h, x = region.x, y = region.y;
    if (w / h > ratio) { var nw = h * ratio; x += (w - nw) / 2; w = nw; } else { var nh = w / ratio; y += (h - nh) / 2; h = nh; }
    btn.disabled = true;
    var framingP = uploadFraming(SC.w / SC.h);        // the sample's picture, rendered now, uploaded while papercrop cuts the file
    requestJSON(CFG.cropApi, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
      origin_url: region.originUrl, product_id: state.product.id, mirror_mode: region.mirror,
      crop_x: Math.round(x * 100) / 100, crop_y: Math.round(y * 100) / 100, crop_width: Math.round(w * 100) / 100, crop_height: Math.round(h * 100) / 100,
      wall_width_cm: SC.w, wall_height_cm: SC.h, effect: state.effect }) })
      .then(function (res) {
        var url = res && res.status === 'success' ? safeCropURL(res.image_url) : '';
        if (!url) throw new Error('crop');
        var props = { 'Décor': state.product.title, 'Width': SC.w + ' cm', 'Height': SC.h + ' cm', 'imageURL': url };
        if (FX_PROP[state.effect]) props['Effet'] = FX_PROP[state.effect];
        if (state.creation) props['Création'] = state.creation;
        return framingP.then(function (preview) {
          if (preview) props['_preview'] = preview;      // private: the thumbnail of the order emails and the cart
          return requestJSON('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(btn.dataset.variant), quantity: Math.ceil(SC.w * SC.h / 10000), properties: props }) });
        });
      })
      .then(function () { refreshCartCount(); openDrawer(); })
      .catch(function () { showError(L('sample_failed')); })
      .finally(function () { btn.disabled = false; });
  }

  function pendingCartKey() { return 'atelier_cart_pending_v1'; }
  var purchaseInFlight = false;
  var pendingPurchase = null;

  function readPendingPurchase() {
    try {
      var raw = sessionStorage.getItem(pendingCartKey());
      if (!raw) return null;
      var value = JSON.parse(raw);
      if (!value || !value.item || !value.item.properties || !value.item.properties._atelier_request_id) throw new Error('invalid');
      return value;
    } catch (e) {
      throw userError('pending_unavailable');
    }
  }

  function rememberPurchase(value) {
    var raw = JSON.stringify(value);
    try {
      sessionStorage.setItem(pendingCartKey(), raw);
      if (sessionStorage.getItem(pendingCartKey()) !== raw) throw new Error('storage');
    } catch (e) {
      throw userError('tracking_unavailable');
    }
    pendingPurchase = value;
  }

  function forgetPurchase() {
    // A successful receipt remains in memory if storage cleanup fails: subsequent
    // clicks reconcile that receipt instead of accidentally adding it twice.
    try {
      sessionStorage.removeItem(pendingCartKey());
      if (!sessionStorage.getItem(pendingCartKey())) pendingPurchase = null;
    } catch (e) { /* retain the pending receipt */ }
  }

  function cartRequestId() {
    if (!window.crypto || !window.crypto.getRandomValues) throw userError('secure_add_unsupported');
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return 'atelier-' + Array.prototype.map.call(bytes, function (n) { return n.toString(16).padStart(2, '0'); }).join('');
  }

  function purchaseControls() {
    return [els.addBtn, els.buyBtn, document.getElementById('stickyAdd')].filter(Boolean);
  }

  function lockPurchaseControls() {
    var buttons = purchaseControls();
    var controls = [els.wInput, els.hInput, els.mirrorMode, els.zoomIn, els.zoomOut, els.toolReset, document.getElementById('fullMode')]
      .concat(Array.prototype.slice.call(els.materials.querySelectorAll('input')))
      .concat(Array.prototype.slice.call(document.querySelectorAll('.fx, .unit-opt')))
      .concat(ratioBtns).filter(Boolean);
    var records = buttons.concat(controls).map(function (el) {
      var rec = { el: el, disabled: el.disabled, html: el.innerHTML };
      el.disabled = true;
      return rec;
    });
    var cropper = state.cropper;
    if (cropper && cropper.disable) cropper.disable();
    return {
      label: function (label) { buttons.forEach(function (el) { el.textContent = label; }); },
      release: function () {
        records.forEach(function (rec) { rec.el.disabled = rec.disabled; if (buttons.indexOf(rec.el) !== -1) rec.el.innerHTML = rec.html; });
        if (cropper && cropper === state.cropper && cropper.enable) {
          cropper.enable();
          resizeCropperPreservingSelection();
        }
      }
    };
  }

  function requestJSON(url, options) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var settings = Object.assign({}, options || {});
    var timeoutMs = settings.timeoutMs; delete settings.timeoutMs;
    if (controller) settings.signal = controller.signal;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error('request_timeout'));
      }, timeoutMs || (url === CFG.cropApi ? 90000 : 20000));
    });
    var request = Promise.resolve().then(function () { return fetch(url, settings); })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error('http_' + response.status);
          return body;
        });
      });
    return Promise.race([request, timeout]).finally(function () { clearTimeout(timer); });
  }

  function exactCartReceipt(line, attempt) {
    var expected = attempt.item;
    if (!line || !line.key || Number(line.variant_id || line.id) !== expected.id ||
        Number(line.product_id) !== attempt.productId || line.quantity !== expected.quantity ||
        !Number.isInteger(line.original_price) || line.original_price !== attempt.unitPrice) return false;
    var properties = line.properties || {};
    return Object.keys(expected.properties).every(function (key) {
      return properties[key] === expected.properties[key];
    });
  }

  function recoverPurchase(attempt) {
    return requestJSON('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('invalid_cart');
        var requestId = attempt.item.properties._atelier_request_id;
        var lines = cart.items.filter(function (line) {
          return line.properties && line.properties._atelier_request_id === requestId;
        });
        if (lines.length !== 1 || !exactCartReceipt(lines[0], attempt)) throw new Error('cart_unconfirmed');
        return lines[0];
      });
  }

  function acceptPurchase(attempt, line) {
    if (!exactCartReceipt(line, attempt)) throw new Error('cart_receipt_mismatch');
    forgetPurchase();
    if (attempt.buyNow) {
      return requestJSON('/cart.js', { cache: 'no-store' })
        .then(function (cart) {
          var result = validateCheckoutCart(cart);
          if (result.ok) { window.location.href = '/checkout'; return; }
          showError(result.message);
          openDrawer();
        })
        .catch(function () {
          showError(L('added_check_cart'));
          window.location.href = ROOT + '/cart';
        });
    }
    try {
      refreshCartCount();
      openDrawer();
    } catch (e) {
      // A rendering error must not be reported as an unconfirmed cart write.
      window.location.href = ROOT + '/cart';
    }
  }

  function purchase(buyNow) {
    if (purchaseInFlight) return Promise.resolve();
    var unresolved;
    try { unresolved = pendingPurchase || readPendingPurchase(); }
    catch (error) { showError(error.message); return Promise.resolve(); }
    if (unresolved) {
      purchaseInFlight = true;
      var recoveryLock = lockPurchaseControls();
      recoveryLock.label(L('checking_your_cart'));
      return recoverPurchase(unresolved)
        .then(function (line) { return acceptPurchase(unresolved, line); })
        .catch(function () {
          showError(L('previous_add_unconfirmed'));
        })
        .finally(function () { purchaseInFlight = false; recoveryLock.release(); });
    }

    // Sync a just-typed value once, but preserve the customer's pan/zoom when the
    // dimensions have not changed since the last input handler.
    onDims();
    if (!validateDims() || !state.product) return Promise.resolve();
    if (!state.cropper) { showError(L('visual_not_ready')); return Promise.resolve(); }
    var variant = currentVariant();
    if (!variant || !Number.isSafeInteger(variant.id) || variant.id <= 0 ||
        !Number.isSafeInteger(variant.price) || variant.price < 0) {
      showError(L('choose_material')); return Promise.resolve();
    }
    var region = cropRegion();
    if (!region || !region.originUrl || !['x', 'y', 'w', 'h'].every(function (key) { return Number.isFinite(region[key]); }) || region.w <= 0 || region.h <= 0) {
      showError(L('crop_not_ready')); return Promise.resolve();
    }
    // The supplier's dimension contract (Width / Height in whole cm, quantity = ceil(m²), imageURL), shared by
    // the sister shops. Geometry remains bounded to the source pixels; the print-DPI guard is papercrop's.

    var snapshot = Object.freeze({
      productId: Number(state.product.id),
      variantId: variant.id,
      unitPrice: variant.price,
      widthCm: state.wcm,
      heightCm: state.hcm,
      quantity: Math.ceil(area()),
      buyNow: !!buyNow,
      region: Object.freeze(region),
      fit: state.fit, effect: state.effect,
      typed: state.unit === 'in' ? els.wInput.value + ' × ' + els.hInput.value + TYPED_UNIT_PROP : ''
    });
    var requestId;
    try { requestId = cartRequestId(); }
    catch (error) { showError(error.message); return Promise.resolve(); }
    var framingP = uploadFraming(0);                  // read from the cropper before it locks; uploaded while papercrop cuts the print file
    purchaseInFlight = true;
    var lock = lockPurchaseControls();
    lock.label(L('preparing_print'));
    var attempt = null;
    var sentCart = false;
    var payload = {
      origin_url: snapshot.region.originUrl,
      product_id: snapshot.productId,
      mirror_mode: snapshot.region.mirror,
      crop_x: snapshot.region.x,
      crop_y: snapshot.region.y,
      crop_width: snapshot.region.w,
      crop_height: snapshot.region.h,
      wall_width_cm: snapshot.widthCm,
      wall_height_cm: snapshot.heightCm,
      fit_mode: snapshot.fit,
      effect: snapshot.effect
    };
    function addToCart(imageUrl, preview) {
      var props = {
        'Width': snapshot.widthCm + ' cm',
        'Height': snapshot.heightCm + ' cm',
        'imageURL': imageUrl.href,
        '_atelier_request_id': requestId
      };
      // private (underscore): the framing thumbnail of the order emails and the cart; absent when its upload failed
      if (preview) props['_preview'] = preview;
      if (state.creation) props['Création'] = state.creation;
      // visible on the cart, checkout and order emails: the customer's choices, confirmed
      if (snapshot.fit === 'full') props['Cadrage'] = FIT_FULL_PROP;
      if (FX_PROP[snapshot.effect]) props['Effet'] = FX_PROP[snapshot.effect];
      if (snapshot.typed) props['Mesures saisies'] = snapshot.typed;
      var properties = Object.freeze(props);
      attempt = Object.freeze({
        productId: snapshot.productId, unitPrice: snapshot.unitPrice, buyNow: snapshot.buyNow,
        item: Object.freeze({ id: snapshot.variantId, quantity: snapshot.quantity, properties: properties })
      });
      rememberPurchase(attempt);
      lock.label(L('adding_to_cart'));
      sentCart = true;
      return requestJSON('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(attempt.item)
      });
    }

    return requestJSON(CFG.cropApi, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    })
      .then(function (result) {
        if (result && result.status !== 'success' && /resolution too low/i.test(result.error_message || '')) throw new Error('low_dpi');
        var imageUrl;
        try { imageUrl = new URL(result.image_url); } catch (e) { throw new Error('invalid_crop_url'); }
        if (result.status !== 'success' || !safeCropURL(result.image_url)) throw new Error('crop_failed');
        return framingP.then(function (preview) { return addToCart(imageUrl, preview); });
      })
      .then(function (line) {
        if (!exactCartReceipt(line, attempt)) throw new Error('cart_receipt_mismatch');
        return line;
      })
      .catch(function (error) {
        if (!sentCart) throw error;
        lock.label(L('checking_your_cart'));
        return recoverPurchase(attempt);
      })
      .then(function (line) { return acceptPurchase(attempt, line); })
      .catch(function (error) {
        if (sentCart) {
          showError(L('add_unconfirmed'));
        } else {
          var em = String(error && error.message || '');
          showError(em === 'low_dpi'
            ? fmt('low_dpi', { w: state.wcm, h: state.hcm })
            : error && error.userFacing ? em : L('crop_failed'));
        }
      })
      .finally(function () { purchaseInFlight = false; lock.release(); });
  }

  if (HAS_TOOL) {
    els.addBtn.addEventListener('click', function () { purchase(false); });
    els.buyBtn.addEventListener('click', function () { purchase(true); });
  }

  /* ————— cart drawer ————— */

  function refreshCartCount() {
    requestJSON('/cart.js', { cache: 'no-store' })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('invalid_cart');
        // item_count sums m² quantities — show number of murals instead
        els.cartCount.textContent = cart.items.length;
      })
      .catch(function () {});
  }

  function openDrawer() {
    els.drawerVeil.hidden = false;
    els.cartDrawer.hidden = false;
    els.drawerClose.focus();
    renderDrawer();
  }
  function closeDrawer() {
    if (els.cartDrawer.hidden) return;
    els.drawerVeil.hidden = true;
    els.cartDrawer.hidden = true;
    els.cartBtn.focus();
  }

  function setDrawerCheckoutState(status) {
    var button = document.getElementById('checkoutBtn');
    if (!button) return;
    button.dataset.cartState = status;
    button.href = ROOT + '/cart'; // new-tab/no-JS use the server-rendered cart gate
    button.setAttribute('aria-disabled', status === 'ready' ? 'false' : 'true');
    button.textContent = status === 'loading' ? L('cart_checking') : status === 'ready' ? L('checkout') : L('cart_verify');
  }

  function renderDrawer() {
    setDrawerCheckoutState('loading');
    els.drawerItems.innerHTML = '<p class="dr-empty">' + esc(L('one_moment')) + '</p>';
    return requestJSON('/cart.js', { cache: 'no-store' })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.total_price)) throw new Error('invalid_cart');
        els.cartCount.textContent = cart.items.length;
        els.drawerTotal.textContent = money(cart.total_price);
        var validation = validateCheckoutCart(cart);
        setDrawerCheckoutState(validation.ok ? 'ready' : 'blocked');
        if (!cart.items.length) {
          els.drawerItems.innerHTML = '<p class="dr-empty">' + esc(L('drawer_empty')) + '</p>';
          return;
        }
        els.drawerItems.innerHTML = (validation.ok ? '' : '<p class="cart-error" role="alert">' + esc(validation.message) + '</p>') + cart.items.map(function (it) {
          var props = it.properties || {};
          var img = safePreviewURL(props._preview) || safeCropURL(props.imageURL) || it.image || '';   // the framing thumbnail, else the print file
          var dims = props.Width ? props.Width + ' × ' + (props.Height || '') : '';
          var lineError = muralCartLineError(it);
          return '<div class="dr-item">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '') +
            '<div class="dr-item-body">' +
            '<p class="dr-item-title">' + esc(it.product_title) + '</p>' +
            '<p class="dr-item-meta">' + esc(it.variant_title || '') + (dims ? ' · ' + esc(dims) : '') +
              // never the quantity of a mural line (billed m², internal): the sizes and the paper type are what is shown
              Object.keys(PROP_LABEL).filter(function (k) { return props[k]; }).map(function (k) { return '<br>' + esc(fmt('prop_line', { label: L(PROP_LABEL[k]), value: propValue(props[k]) })); }).join('') + '</p>' +
            '<p class="dr-item-price">' + money(it.final_line_price) + '</p>' +
            (lineError ? '<p class="cart-error">' + esc(lineError) + '</p><a href="' + esc(productConfigurationURL(it)) + '">' + esc(L('reconfigure')) + '</a> · ' : '') +
            '<button type="button" class="dr-remove" data-key="' + esc(it.key) + '" data-request-id="' + esc(props._atelier_request_id || '') + '">' + esc(L('remove')) + '</button>' +
            '</div></div>';
        }).join('');
      })
      .catch(function () {
        setDrawerCheckoutState('blocked');
        els.drawerItems.innerHTML = '<p class="dr-empty">' + fmt('drawer_check_failed_html', { url: esc(ROOT + '/cart') }) + '</p>';
      });
  }

  var drawerCheckout = document.getElementById('checkoutBtn');
  if (drawerCheckout) {
    setDrawerCheckoutState('blocked');
    drawerCheckout.addEventListener('click', function (event) {
      event.preventDefault();
      if (drawerCheckout.dataset.cartState === 'loading') return;
      if (drawerCheckout.dataset.cartState !== 'ready') { window.location.href = ROOT + '/cart'; return; }
      setDrawerCheckoutState('loading');
      requestJSON('/cart.js', { cache: 'no-store' })
        .then(function (cart) {
          if (validateCheckoutCart(cart).ok) { window.location.href = '/checkout'; return; }
          return renderDrawer();
        })
        .catch(function () {
          setDrawerCheckoutState('blocked');
          els.drawerItems.innerHTML = '<p class="cart-error" role="alert">' + fmt('checkout_check_failed_html', { url: esc(ROOT + '/cart') }) + '</p>';
        });
    });
  }

  els.drawerItems.addEventListener('click', function (e) {
    var btn = e.target.closest('.dr-remove');
    if (!btn) return;
    if (btn.disabled) return;
    btn.disabled = true;
    setDrawerCheckoutState('loading');
    requestJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
    }).then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || cart.items.some(function (item) { return item.key === btn.dataset.key; })) throw new Error('remove_unconfirmed');
      clearRemovedPendingPurchase(btn.dataset.requestId, cart);
      renderDrawer();
    }).catch(function () {
      toast(L('cart_change_unconfirmed'));
      renderDrawer();
    }).finally(function () { btn.disabled = false; });
  });

  els.cartBtn.addEventListener('click', openDrawer);
  els.drawerClose.addEventListener('click', closeDrawer);
  els.drawerVeil.addEventListener('click', closeDrawer);

  /* ————— mockup lightbox (navigable gallery) ————— */

  state.mockupList = [];
  state.lightboxIdx = 0;

  function showLightbox(idx) {
    var list = state.mockupList;
    if (!list.length) return;
    state.lightboxIdx = ((idx % list.length) + list.length) % list.length;
    els.lightboxImg.src = list[state.lightboxIdx];
    if (els.lightboxCount) els.lightboxCount.textContent = fmt('lightbox_count', { i: state.lightboxIdx + 1, n: list.length });
    var single = list.length < 2;
    if (els.lightboxPrev) els.lightboxPrev.hidden = single;
    if (els.lightboxNext) els.lightboxNext.hidden = single;
    if (els.lightboxCount) els.lightboxCount.hidden = single;
    els.lightbox.hidden = false;
  }

  if (els.mockups) els.mockups.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-full]');
    if (!btn) return;
    var idx = parseInt(btn.dataset.idx || '0', 10);
    state.mediaIdx = idx;
    var mainImg = document.getElementById('mediaMainImg');
    if (mainImg && state.mockupList[idx]) mainImg.src = sized(state.mockupList[idx], 1200);
    els.mockups.querySelectorAll('.media-thumb').forEach(function (t) {
      t.classList.toggle('is-on', t === btn);
    });
  });
  var mediaMainBtn = document.getElementById('mediaMainBtn');
  if (mediaMainBtn) mediaMainBtn.addEventListener('click', function () {
    showLightbox(state.mediaIdx || 0);
    els.lightboxClose.focus();
  });
  els.lightboxPrev.addEventListener('click', function () { showLightbox(state.lightboxIdx - 1); });
  els.lightboxNext.addEventListener('click', function () { showLightbox(state.lightboxIdx + 1); });
  els.lightboxClose.addEventListener('click', function () { els.lightbox.hidden = true; });
  els.lightbox.addEventListener('click', function (e) {
    if (e.target === els.lightbox) els.lightbox.hidden = true;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { els.lightbox.hidden = true; closeDrawer(); closeMenu(); }
    if (!els.lightbox.hidden) {
      if (e.key === 'ArrowLeft') showLightbox(state.lightboxIdx - 1);
      if (e.key === 'ArrowRight') showLightbox(state.lightboxIdx + 1);
    }
  });


  /* ————— promo banner: welcome code against an email —————
     Rendered only with a code and the assistant service (theme settings promo_*, assistant_api). The email
     goes to the service's POST /v1/subscribe, which records the Shopify customer; the newsletter tags and the marketing
     consent only when the separate, unticked box is ticked (`marketing: true` + the wording shown). Only a transient failure (network, 429, 5xx) is kept and sent again on the next
     pages, PENDING_TRIES sends in all; any other answer (400 bad_email, 403 origin, 404 route missing) is final. */

  var SUBSCRIBE_URL = CFG.assistantApi ? CFG.assistantApi.replace(/\/+$/, '') + '/v1/subscribe' : '';
  var PENDING = 'atelier_email_pending', PENDING_TRIES = 5;
  // mk = the box was ticked; the wording sent is the text of the notice as displayed (box + note), the service keeps it as proof
  function consentShown() { var n = document.getElementById('promoConsent'); return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function subscribe(em, tries, mk) {
    return fetch(SUBSCRIBE_URL, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: em, locale: LOCALE, source: 'promo_banner', marketing: !!mk, marketing_text: mk ? consentShown() : '' }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { return { status: r.status, b: b }; }); })
      .then(function (res) {
        if (res.status === 200 && res.b && res.b.ok) { lsDel(PENDING); return true; }
        if (res.status !== 429 && res.status < 500) { lsDel(PENDING); return false; }   // refused: never retried
        throw new Error('subscribe');
      })
      .catch(function () {
        var n = (tries || 0) + 1;
        if (n < PENDING_TRIES) lsSet(PENDING, JSON.stringify({ email: em, n: n, mk: !!mk })); else lsDel(PENDING);
        return false;
      });
  }
  var pendingEmail = lsJSON(PENDING, null);
  if (!(pendingEmail && pendingEmail.email) && lsGet(PENDING)) pendingEmail = { email: lsGet(PENDING), n: 0 };   // older themes stored the bare address
  if (SUBSCRIBE_URL && pendingEmail) subscribe(pendingEmail.email, pendingEmail.n, pendingEmail.mk === true);   // an older record has no `mk`: no consent

  var promo = document.getElementById('promo');
  if (promo && SUBSCRIBE_URL) (function () {
    var LS_PROMO = 'atelier_promo';
    var pst = lsJSON(LS_PROMO, {});
    var cta = document.getElementById('promoCta');
    var form = document.getElementById('promoForm');
    var emailIn = document.getElementById('promoEmail');
    var done = document.getElementById('promoDone');
    var consent = document.getElementById('promoConsent');
    var mkBox = document.getElementById('promoMk');
    var x = document.getElementById('promoX');
    function save(patch) {
      Object.keys(patch).forEach(function (k) { pst[k] = patch[k]; });
      lsSet(LS_PROMO, JSON.stringify(pst));
    }
    if (pst.hidden) return; // dismissed for good
    promo.hidden = false;
    if (pst.done) { cta.hidden = true; done.hidden = false; }
    cta.addEventListener('click', function () {
      cta.hidden = true;
      form.hidden = false;
      if (consent) consent.hidden = false;   // the notice sits under the field: shown with it
      emailIn.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = (emailIn.value || '').trim().toLowerCase();
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,24}$/i.test(em)) { emailIn.focus(); emailIn.setCustomValidity(L('email_invalid')); emailIn.reportValidity(); return; }
      // Shopify's storefront customer form 400s on fetch posts ("Missing
      // CAPTCHA token") — the assistant service creates the customer via the Admin API instead
      subscribe(em, 0, !!(mkBox && mkBox.checked))
        .finally(function () {
          // the code is shown regardless: never lose the purchase moment
          save({ done: true, email: em });
          form.hidden = true;
          if (consent) consent.hidden = true;
          done.hidden = false;
        });
    });
    x.addEventListener('click', function () {
      promo.hidden = true;
      save({ hidden: true });
    });
  })();

  /* ————— "Voir sur votre mur" — the assistant's wall preview —————
     #vsmFab / #pdpWallBtn are rendered only with the assistant_api setting; the route is chosen at click
     time because assistant.js runs after this script. */

  function wallPreview() { if (window.MPPAssistant) assistantPreview(); }
  if (HAS_TOOL) ['vsmFab', 'pdpWallBtn'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', wallPreview);
  });


  /* ————— slide-in nav ————— */

  var menuBtn = document.getElementById('menuBtn');
  var mnav = document.getElementById('mnav');
  var mnavVeil = document.getElementById('mnavVeil');
  var mnavClose = document.getElementById('mnavClose');

  function openMenu() {
    mnavVeil.hidden = false;
    mnav.hidden = false;
    menuBtn.setAttribute('aria-expanded', 'true');
    mnavClose.focus();
  }
  function closeMenu() {
    if (!mnav || mnav.hidden) return;
    mnavVeil.hidden = true;
    mnav.hidden = true;
    menuBtn.setAttribute('aria-expanded', 'false');
    menuBtn.focus();
  }
  if (menuBtn && mnav) {
    menuBtn.addEventListener('click', openMenu);
    mnavClose.addEventListener('click', closeMenu);
    mnavVeil.addEventListener('click', closeMenu);
  }

  /* ————— mobile sticky CTA ————— */

  function buildStickyCta() {
    var bar = document.createElement('div');
    bar.className = 'sticky-cta';
    bar.innerHTML = '<span class="sticky-price" id="stickyPrice">—</span>' +
      '<button class="btn btn-accent" type="button" id="stickyAdd">' + esc(L('add_to_cart')) + '</button>';
    document.body.appendChild(bar);
    bar.querySelector('#stickyAdd').addEventListener('click', function () {
      document.getElementById('studio').scrollIntoView({ behavior: 'smooth' });
      purchase(false);
    });
  }

  /* ————— boot ————— */

  var initial = readJSON('a-selected');
  if (initial && HAS_TOOL) {
    var p = normProduct(initial);
    p.description = CFG.template === 'product' && els.pDesc ? els.pDesc.innerHTML : null;
    if (p.description == null) {
      fetch(ROOT + '/products/' + p.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (raw) {
          if (state.product && state.product.handle === p.handle) {
            p.description = raw.description || '';
            els.pDesc.innerHTML = p.description;
          }
        })
        .catch(function () {});
    }
    state.cache[p.handle] = p;
    state.product = p;
    state.entryHandle = p.handle;
    history.replaceState({ handle: p.handle }, '', location.href);
    els.cropImg.addEventListener('load', function onFirst() {
      els.cropImg.removeEventListener('load', onFirst);
      initCropper();
    });
    if (els.cropImg.complete && els.cropImg.naturalWidth) initCropper();
    highlightCard(p.handle);
  }

  // A customer's own creation (assistant): /products/<creation product>?creation=<id> loads that
  // design into the cropper. Only the device that created it can read it (assistant account).
  (function loadCreation() {
    var cid = new URLSearchParams(location.search).get('creation');
    var asCfg = readJSON('as-config');
    if (!cid || !HAS_TOOL || CFG.template !== 'product' || !asCfg || !asCfg.api) return;
    var account = (lsJSON('mpp_assistant_v1', {}) || {}).account;
    if (!account) { toast(L('creation_other_device')); return; }
    fetch(asCfg.api.replace(/\/+$/, '') + '/v1/creations/' + encodeURIComponent(cid), { headers: { Authorization: 'Bearer ' + account } })
      .then(function (r) { if (!r.ok) throw new Error('creation'); return r.json(); })
      .then(function (c) {
        // the service gives the design's pixel size (width / height); 0 = read from the loaded image
        var p = Object.assign({}, state.product, { title: c.title, images: [c.room, c.design], designW: c.width || 0, designH: c.height || 0, description: '<p>' + esc(c.wish) + '</p>' });
        state.creation = c.creation;
        hydrate(p);
      })
      .catch(function () { toast(L('creation_not_found')); });
  })();

  var pdpSampleBtn = document.getElementById('pdpSampleBtn');
  if (pdpSampleBtn) pdpSampleBtn.addEventListener('click', function () { orderSample(pdpSampleBtn); });
  var pdpProjectBtn = document.getElementById('pdpProjectBtn');
  if (pdpProjectBtn) pdpProjectBtn.addEventListener('click', function () {
    var msg = state.product ? (state.creation
        ? fmt('project_design_creation', { title: state.product.title, id: state.creation, url: state.product.images[state.product.images.length - 1] })
        : fmt('project_design_product', { title: state.product.title, url: location.origin + state.product.url })) +
        '\n' + fmt('project_wall', { w: state.wcm, h: state.hcm }) + '\n\n' : '';
    if (window.MPPAssistant) window.MPPAssistant.contact(msg);
    else if (SHOP.contactUrl) location.href = SHOP.contactUrl;
  });

  // remember the SSR heading so "← Retour" from favorites can restore it
  if (els.exploreTitle) state.chipTitle = els.exploreTitle.textContent;

  // seed the cache from server-rendered card payloads (favorites/instant select need it)
  els.grid.querySelectorAll('.card-link[data-payload]').forEach(function (link) {
    try {
      var sp = normProduct(JSON.parse(link.dataset.payload));
      if (!state.cache[sp.handle]) state.cache[sp.handle] = sp;
    } catch (e) {}
  });

  // related grid: continue from the SSR page (?page=N); its first card marks that page
  state.autoLeft = AUTO_PAGES;
  state.firstPage = state.page;
  state.baseTitle = document.title.replace(PAGE_RE, '');
  var firstCard = els.grid.querySelector('.card');
  if (firstCard) firstCard.dataset.page = state.page;
  updateGridStatus();
  armOnInteraction();
  if (COLLECTION_PATH) window.addEventListener('scroll', onScrollReflect, { passive: true });

  if (HAS_TOOL) {
    // seed the mockup gallery list from the SSR thumbnails
    state.mockupList = Array.prototype.map.call(
      els.mockups.querySelectorAll('button[data-full]'),
      function (b, i) { b.dataset.idx = i; return b.dataset.full; }
    );
    buildStickyCta();
    updatePrice();
  }
  syncFavUI();
  syncCheckedClasses();
  refreshCartCount();
})();
